import { configuration } from '/src/config'

function Logout ({ className, ...rest }) {
  window.localStorage.removeItem('enea-accessToken')
  window.location.assign(`${configuration.authPlatformLogin}`)
  return null
}
export default Logout
